"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAutocompleteSuggestion = exports.FdrAutocompleteSuggestions = void 0;
const noop_1 = __importDefault(require("lodash/noop"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const fdr_regular_fusion_fdr_autocomplete_context_1 = require("@hotelplan/fdr.regular.fusion.fdr-autocomplete-context");
const fdr_combobox_styles_1 = require("./fdr-combobox.styles");
function FdrAutocompleteSuggestions(props) {
    var _a;
    const { children } = props, rest = __rest(props, ["children"]);
    const ctx = (0, fdr_regular_fusion_fdr_autocomplete_context_1.useFdrAutocompleteContext)();
    const noPage = !ctx.pagination;
    const noSuggestions = ctx.suggestions.length === 0;
    const firstPageLoading = noPage && ctx.pageNumberExpected === 0 && ctx.loading;
    const hideSuggestions = firstPageLoading || noSuggestions || noPage;
    if (!ctx.loading && noSuggestions)
        return null;
    return (react_1.default.createElement(fdr_combobox_styles_1.AutocompleteSuggestionsWrap, { "data-id": "suggestions-container", className: "autocomplete-suggestions" },
        !hideSuggestions && (react_1.default.createElement(fdr_combobox_styles_1.SuggestionListBox, Object.assign({ role: "listbox" }, rest), ctx.suggestions.map((item, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index }, children(item, ctx, index === ctx.selectedSuggestion)))))),
        ((_a = props === null || props === void 0 ? void 0 : props.suggestionsExtraButton) === null || _a === void 0 ? void 0 : _a.show) ? (react_1.default.createElement("div", { className: "autocompleteFooterWrap" },
            !ctx.loading ? props === null || props === void 0 ? void 0 : props.suggestionsExtraButton.button : null,
            react_1.default.createElement(FdrAutocompletePagination, { withoutWrapper: props === null || props === void 0 ? void 0 : props.suggestionsExtraButton.show }))) : (react_1.default.createElement(FdrAutocompletePagination, null))));
}
exports.FdrAutocompleteSuggestions = FdrAutocompleteSuggestions;
const FdrAutocompleteSuggestion = (_a) => {
    var { active, children, onClick = noop_1.default } = _a, liProps = __rest(_a, ["active", "children", "onClick"]);
    return (react_1.default.createElement(fdr_combobox_styles_1.AutocompleteSuggestionItem, Object.assign({ as: "li", active: active }, liProps, { tabIndex: -1, role: "option", onClick: onClick, 
        // Prevent losing focus after clicking element
        onMouseDown: (e) => e.preventDefault(), "data-id": "autocomplete-option" }), children));
};
exports.FdrAutocompleteSuggestion = FdrAutocompleteSuggestion;
function FdrAutocompletePagination(props) {
    var _a, _b;
    const { loader: customLoader, children } = props;
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const ctx = (0, fdr_regular_fusion_fdr_autocomplete_context_1.useFdrAutocompleteContext)();
    const { page = 0, total = 0, perPage = 0 } = (ctx.pagination ||
        {});
    const leftToLoad = total ? total - ctx.suggestions.length : 0;
    const resultsExpected = leftToLoad < (perPage || 0) ? leftToLoad : perPage;
    const loader = customLoader || (() => t('common:loading'));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ctx.loading ? loader(resultsExpected) : null,
        typeof children === 'function' ? children(ctx) : null,
        !ctx.loading &&
            ((_a = ctx.pagination) === null || _a === void 0 ? void 0 : _a.total) &&
            ((_b = ctx.pagination) === null || _b === void 0 ? void 0 : _b.total) > ctx.suggestions.length &&
            ctx.pageNumberExpected === page ? (react_1.default.createElement(FdrAutocompleteMoreButton, { withoutWrapper: props.withoutWrapper })) : null));
}
const FdrAutocompleteMoreButton = props => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const ctx = (0, fdr_regular_fusion_fdr_autocomplete_context_1.useFdrAutocompleteContext)();
    function onClick(e) {
        var _a;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        ctx.nextPage();
    }
    if (props === null || props === void 0 ? void 0 : props.withoutWrapper) {
        return (react_1.default.createElement(fdr_combobox_styles_1.LoadMoreButton, Object.assign({ variant: "linkBtn", "data-id": "load-more" }, props, { onClick: onClick }), t('common:load.more')));
    }
    return (react_1.default.createElement(fdr_combobox_styles_1.AutocompleteMoreButtonWrap, null,
        react_1.default.createElement(fdr_combobox_styles_1.LoadMoreButton, Object.assign({}, props, { onClick: onClick }), t('common:load.more'))));
};
//# sourceMappingURL=fdr-combobox-suggestions.js.map